import 'jquery';

export const getHouses = (filter,productFilter,paginator) => {

    return $.get(`/vivapark/ajaxGetHouses/${filter}?productFilter=${productFilter}&page=${paginator.currentPage}&limit=${paginator.itemPerPage}`);
};

export const getHousesWithFilters = (filter,productFilter,propertyFilters,paginator) => {
    filter = filter.length>0 ? '/'+filter: '';
    return $.post(`/vivapark/ajaxGetHouses${filter}`,{
        productFilter:productFilter,
        propertyFilters: propertyFilters,
        page:paginator.currentPage,
        limit:paginator.itemPerPage,
    });
};

